import { useTranslation } from '@thoughtspot/i18n';
import React, { useEffect, useState } from 'react';
import { useGetOrgsListQuery } from "../../../../services/org/org-service";
import { AddUsersToOrgModal } from './add-users-to-org-modal';
export const AddUsersToOrgModalContainer = ({ onAddUsersToOrgConfirm, onAddUsersToOrgModalClose, isModalOpen, }) => {
    const { t } = useTranslation();
    const [orgList, setOrgList] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState('');
    const [orgListInput, setOrgListInput] = useState({
        sort: 'DEFAULT',
        sortascending: true,
        batchsize: 100,
        offset: 0,
        pattern: '',
    });
    const { data: orgsList, error: orgsListError, loading: orgsListLoading, refetch: refreshOrgList, } = useGetOrgsListQuery(orgListInput);
    useEffect(() => {
        if (isModalOpen) {
            refreshOrgList({ data: orgListInput });
        }
    }, [isModalOpen]);
    useEffect(() => {
        setOrgList(orgsList?.Data.orgs);
    }, [orgsList]);
    const updateOrgListPayload = (searchTerm) => {
        setOrgListInput({
            ...orgListInput,
            pattern: searchTerm,
        });
    };
    return (React.createElement(AddUsersToOrgModal, { isModalOpen: isModalOpen, onAddUsersToOrgConfirm: onAddUsersToOrgConfirm, onAddUsersToOrgModalClose: onAddUsersToOrgModalClose, orgList: orgList, updateOrgListPayload: updateOrgListPayload, showLoader: orgsListLoading, setSelectedOrg: setSelectedOrg, selectedOrg: selectedOrg }));
};
//# sourceMappingURL=add-users-to-org-modal.container.js.map